import React, { useEffect, useState, useRef, useMemo } from "react";
import { useReactToPrint } from "react-to-print";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { Paper, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import { WHITE, PRIMARY_LIGHT_BLUE } from "../../colors";
import HeightBox from "../../components/HeightBox";
import CustomerService from "../../services/customerService";
import FormEditService from "../../services/formEditService";
import { LETTER } from "../../constants/formTypes";
import { useHistory } from "react-router-dom";
import { APPROVED, IN_DRAFT, NEW_FORM } from "../../constants/formStates";
import FormStateLabel from "./FormStateLabel";
import { LetterPrintOut } from "../../components/Printouts/LettrtPrintOut";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import { createEditor } from "slate";
import RichText from "../../components/richtext/RichText";

// Import the Slate components and React plugin.
import { Slate, Editable, withReact } from "slate-react";

const Container = styled(Paper)(({ theme }) => ({
  backgroundColor: "#F5F6F8",
  borderRadius: 10,
  paddingTop: 20,
  paddingLeft: 20,
  paddingBottom: 20,
  opacity: 0.9,
  boxShadow: "0px 5px 20px rgba(0, 0, 0, 0.05)",
}));
const CustomTypography = styled(Typography)(({ theme }) => ({
  fontSize: 18,
}));
const CustomTextField = styled(TextField)(({ theme }) => ({
  width: 750,
  backgroundColor: WHITE,
  outline: "none",
  borderRadius: 10,
  border: "0px solid #fff",
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover": {
    border: "0px solid #484850",
  },
  "&:focus-within": {
    border: "0px solid #484850",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
}));
const CustomButton = styled(Button)(({ theme }) => ({
  paddingLeft: 10,
  backgroundColor: PRIMARY_LIGHT_BLUE,
  height: 42,
  minWidth: 155,
  color: WHITE,
  textTransform: "none",
  fontSize: 18,
  fontWeight: 700,
  borderRadius: 10,
}));
const ErrorMessage = styled(Typography)(({ theme }) => ({
  color: "red",
  fontSize: 13,
}));

const initialValues = {
  greeting: null,
  title: null,
  customerName: null,
  letterBody: null,
  passport: null,
  signatureText: null,
};

export default function Letter(props) {
  const editor = useMemo(() => withReact(createEditor()), []);
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const [formValues, setFormValues] = useState(initialValues);
  const [pageInfo, setPageInfo] = useState({
    isDraft: false,
    isCreated: false,
  });
  let history = useHistory();
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const handleSubmit = async () => {
    const res = submitAndPrint();
  };
  const submitAndPrint = async () => {
    try {
      const res = await FormEditService.createFormEdit(formValues);

      handlePrint();
      alert("Successfully submitted the Application for Review");
      setTimeout(function () {
        history.push("/forms");
      }, 5000);

      return true;
    } catch (e) {
      alert(e);
    }
  };

  useEffect(async () => {
    setIsDataLoaded(true);
    let newPageInfo = {
      isDraft: false,
      isCreated: false,
    };
    const getCustomer = async () => {
      const res = await CustomerService.getCustomerById(props.customer);
      return res.data;
    };
    const getFormDetails = async () => {
      let res;
      if (props.letterId !== null) {
        res = await FormEditService.getFormEditById(props.letterId);
      } else {
        res = await FormEditService.getFormEditByCustomerAnType(props.customer, { type: LETTER });
      }
      return res.data;
    };

    let titleTest;
    let greetingTest;
    let letterBodyTest;
    let signatureTest;
    try {
      const { id, isDraft, title, greeting, letterBody, signatureText } = await getFormDetails();
      titleTest = title || "";
      greetingTest = greeting || "";
      letterBodyTest = letterBody || "";
      signatureTest = signatureText || "";
      newPageInfo = {
        isDraft,
        isCreated: true,
      };
    } catch (error) {}

    const { dob, full_name, nic, customerName, passport } = await getCustomer();

    setFormValues({
      greeting: greetingTest,
      title: titleTest,
      customer: props.customer,
      type: LETTER,
      customerName: full_name,
      letterBody: letterBodyTest,
      passport,
      signatureText: signatureTest,
    });

    setPageInfo({ ...newPageInfo });
    setIsDataLoaded(false);
  }, [props.customer]);
  if (typeof props.customer !== "number") {
    return (
      <Container>
        <h2>Please select a customer</h2>
      </Container>
    );
  }

  return (
    <Container>
      <FormStateLabel type={pageInfo.isDraft ? IN_DRAFT : pageInfo.isCreated ? APPROVED : NEW_FORM} />
      <HeightBox height={10} />
      {isDataLoaded && (
        <Box
          sx={{
            width: "100%",
            height: "30vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress size={60} />
        </Box>
      )}
      {!isDataLoaded && (
        <>
          {" "}
          <Stack direction="row" spacing={5}>
            <Stack direction="column" spacing={2}>
              <HeightBox height={4} />
              <CustomTypography>To/ Greeting:</CustomTypography>
              <HeightBox height={270} />
              <CustomTypography>Title:</CustomTypography>
              <HeightBox height={10} />
              <CustomTypography>Customer Name:</CustomTypography>
              <HeightBox height={10} />
              <CustomTypography>Passport Number:</CustomTypography>
              <HeightBox height={10} />
              <CustomTypography>Letter body:</CustomTypography>
              <HeightBox height={250} />
              <CustomTypography>Signature Text:</CustomTypography>
            </Stack>

            <Stack direction="column" spacing={2}>
              <RichText
                content={formValues.greeting}
                setContent={(val) => setFormValues({ ...formValues, greeting: val })}
              />
              <CustomTextField
                value={formValues.title}
                onChange={(e) =>
                  setFormValues({
                    ...formValues,
                    title: e.target.value,
                  })
                }
              />
              <CustomTextField
                value={formValues.customerName}
                InputProps={{ disableUnderline: true, readOnly: true }}
              />
              <CustomTextField value={formValues.passport} InputProps={{ disableUnderline: true, readOnly: true }} />

              <RichText
                content={formValues.letterBody}
                setContent={(val) => setFormValues({ ...formValues, letterBody: val })}
              />
              <RichText
                content={formValues.signatureText}
                setContent={(val) => setFormValues({ ...formValues, signatureText: val })}
              />
            </Stack>
          </Stack>
          <HeightBox height={20} />
          <Stack direction="row-reverse">
            <div style={{ width: 640 }} />
            <div>
              {/* <ReactToPrint trigger={() => <CustomButton>Print</CustomButton>} content={() => componentRef.current} /> */}
              <div style={{ display: "none" }}>
                <LetterPrintOut ref={componentRef} formValues={formValues} />
              </div>
            </div>
            {pageInfo.isCreated && (
              <CustomButton type="button" onClick={handlePrint}>
                Print{" "}
              </CustomButton>
            )}
            <div style={{ width: 20 }} />
            {!pageInfo.isDraft && pageInfo.isCreated && <CustomButton onClick={submitAndPrint}>Submit </CustomButton>}
            <div style={{ width: 20 }} />
            {!pageInfo.isDraft && !pageInfo.isCreated && (
              <CustomButton onClick={handleSubmit}>Submit & Print </CustomButton>
            )}
          </Stack>
        </>
      )}
    </Container>
  );
}
